import React, { useContext } from 'react';
import { Route, Switch } from 'react-router';
import ScrollToTop from 'react-router-scroll-top';
import injectContext, { Context } from '../services/context/context_api';
import ProjectDetail from '../modules/project_detail/pages/project_detail';
import Loading from '../shared/components/spinner/loading';
import ProjectList from '../modules/properties_index/pages/properties_index';
import Header from '../shared/header/header';
import Footer from '../shared/footer/footer';

function Router() {
  const { store } = useContext(Context);

  return (
    <>
      <Loading open={store.isFetching} />
      <Header
        header={{
          logo: {
            url: 'https://cdn.homierent.com/strapi-media/homierent_logo_6eb6830555.svg',
            link: 'https://homierent.com/cl',
          },
          tooltip: '¿Eres propietario? Anuncia tu inmueble',
          searchBoxPlaceholder: 'Busca tu Hogar',
          userType: 'tenant',
          mainNavOptions: [
            {
              title: 'Arrendar',
              link: 'https://homierent.com/cl/arriendo/propiedades-en-arriendo-en-chile',
              newTab: false,
              typeOption: 'tenants',
              subLinks: [],
            },
            {
              title: 'Comprar',
              link: 'https://homierent.com/cl/venta',
              newTab: false,
              typeOption: 'tenants',
              subLinks: [],
            },
            {
              title: 'Pagar arriendo',
              link: 'https://btg-4540.my.salesforce-sites.com/arrendatarios',
              newTab: false,
              typeOption: 'owners',
              subLinks: [],
            },
            {
              title: 'Contáctanos',
              link: 'https://soporte.homierent.com',
              newTab: false,
              typeOption: 'tenants',
              subLinks: [],
            },
          ],
          mainNavMenu: [
            {
              title: 'Acceso Inversionista',
              link: 'https://clientes.homierent.com',
              newTab: false,
            },
            {
              title: 'Centro de ayuda',
              link: 'https://soporte.homierent.com',
              newTab: false,
            },
          ],
          mainNavMenuMobile: [
            {
              title: 'Acceso Inversionista',
              link: 'https://clientes.homierent.com',
              newTab: false,
            },
            {
              title: 'Centro de ayuda',
              link: 'https://soporte.homierent.com',
              newTab: false,
            },
          ],
          cta: {
            title: 'Publicar propiedad',
            link: 'https://homierent.com/cl/inversionistas',
            newTab: false,
          },
        }}
      />
      <ScrollToTop>
        <Switch>
          <Route exact path='/cl/venta/:id'>
            <ProjectDetail />
          </Route>
          <Route exact path='/cl/venta'>
            <ProjectList />
          </Route>
        </Switch>
      </ScrollToTop>
      <Footer
        footer={{
          brandName: 'Homierent',
          logo: {
            url: 'https://cdn.homierent.com/strapi-media/homierent_logo_6eb6830555.svg',
            link: 'https://homierent.com/cl',
          },
          links: [
            {
              title: 'Centro de ayuda',
              link: [
                {
                  title: 'Soporte a clientes',
                  link: 'https://soporte.homierent.com/',
                  nofollow: true,
                },
              ],
            },
            {
              title: '¿Qué quieres hacer?',
              link: [
                {
                  title: 'Pagar arriendo',
                  link: 'https://btg-4540.my.salesforce-sites.com/arrendatarios',
                  nofollow: true,
                },
                {
                  title: 'Arrendar',
                  link: 'https://homierent.com/cl/arriendo/propiedades-en-arriendo-en-chile',
                  nofollow: true,
                },
                {
                  title: 'Comprar',
                  link: 'https://homierent.com/cl/venta',
                  nofollow: true,
                },
                {
                  title: 'Encontrar un arrendatario',
                  link: 'http://homierent.com/cl/inversionistas',
                  nofollow: true,
                },
              ],
            },
            {
              title: 'Legales',
              link: [
                {
                  title: 'Términos y Condiciones',
                  link: 'https://homierent.com/cl/inversionistas/terminos-condiciones',
                  nofollow: true,
                },
                {
                  title: 'Requisitos de asegurabilidad',
                  link: 'https://homierent.com/cl/inversionistas/requisitos-asegurabilidad',
                  nofollow: true,
                },
              ],
            },
          ],
          socialLinks: [
            {
              title: 'Facebook',
              url: 'https://www.facebook.com/CapitalizarmeRent',
              icon: {
                url: 'https://cdn.homierent.com/strapi-media/facebook_26c981d7ab.svg',
              },
            },
            {
              title: 'Instagram',
              url: 'https://www.instagram.com/capitalizarmerent/',
              icon: {
                url: 'https://cdn.homierent.com/strapi-media/instagram_5359677cc1.svg',
              },
            },
            {
              title: 'YouTube',
              url: 'https://www.youtube.com/channel/UCmfaJxIg5C7FwpsxWy0gzIQ',
              icon: {
                url: 'https://cdn.homierent.com/strapi-media/You_Tube_bc46b6336d.svg',
              },
            },
            {
              title: 'Linkedin',
              url: 'https://www.linkedin.com/authwall?trk=bf&trkInfo=AQENFQG2wKVAkAAAAXuiK-GwTTKLHGJNeeWwIYK4B9Nd4iSSO06G3GftFCQcdTbwOykEFZvQXzzZjSwle6pLX314mFc8rJIFtZ_Q5jeq26pxkc7WzrzlApSYeaGePTAZCIYD7uE=&originalReferer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fcapitalizarme-rent',
              icon: {
                url: 'https://cdn.homierent.com/strapi-media/linkedin_6afc9b71c5.svg',
              },
            },
          ],
        }}
      />
    </>
  );
}

export default injectContext(Router);
